(function ($) {
  'use strict';

  this.CyclingTrips = function () {
    this.resizeTimeout = null;

    this.$routeInfo = $('main > header, main > section:not(.map)');

    this.wrapped = false;

    this.initialized = null;

    this.debug = false;

    this.$mapWrapper = $('section.map');
    this.$map = $('#mapContainer');

    if (this.$map.length < 1) {
      if (CTA.debug) {
        console.log('The map container could not be found: #mapContainer');
      }
      return;
    }

    this.initialize();
    this.positionMap();
    this.rating();

    this.initialized = true;

    this.resized = function () {
      this.$map.css('position', 'absolute');
      this.$map.css('top', 0);
      this.positionMap();

      // Timeout for resizing the window, so we do not fire this several times at once
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }
      var t = this;
      this.resizeTimeout = setTimeout(function () {
        t.initialize();
      }, 250);
    };

    $(document).on(
      'CyclingTrips:updateMapPosition',
      this.positionMap.bind(this)
    );

    $(window).on('scroll', this.positionMap.bind(this));
    $(window).on('resize', this.resized.bind(this));
  };

  this.CyclingTrips.prototype.positionMap = function () {
    var yAxis = window.pageYOffset - this.$mapWrapper.offset().top;
    if (yAxis <= 0) {
      this.$map.css('top', 0);
      this.$map.css('left', 0);
      this.$map.css('position', 'absolute');
      return;
    }

    var maxOffset = this.$mapWrapper.outerHeight() - this.$map.outerHeight();
    if (yAxis > maxOffset) {
      this.$map.css('top', maxOffset);
      this.$map.css('left', 0);
      this.$map.css('position', 'absolute');
    } else if (this.$map.css('position') !== 'fixed') {
      this.$map.css('top', 0);
      this.$map.css('left', this.$mapWrapper.offset().left);
      this.$map.css('position', 'fixed');
    }
  };

  /*
   * Decide whether to wrap the trip sidebar or not
   */
  this.CyclingTrips.prototype.initialize = function () {
    var width = $(window).width();
    if (width >= 1024 && !this.wrapped) {
      this.$routeInfo.wrapAll('<div class="trips-sidebar" />');
      this.svgFix(this.$routeInfo);
      this.wrapped = true;
      if (this.initialized) {
        $(document).trigger('CyclingTrips:mapSectionReorder');
      }
    } else if (width < 1024 && this.wrapped) {
      this.$routeInfo.unwrap();
      this.svgFix(this.$routeInfo);
      this.wrapped = false;
      if (this.initialized) {
        $(document).trigger('CyclingTrips:mapSectionReorder');
      }
    }
    this.positionMap();
  };

  this.CyclingTrips.prototype.svgFix = function (element) {
    element.find('svg').each(function () {
      var t = $(this);
      t.parent().html(t.parent().html());
    });
  };

  this.CyclingTrips.prototype.getZoomControl = function (map) {
    var zoomInButton = '<a class="zoom-in">' + new WLCIcon('plus') + '</a>';
    var zoomOutButton = '<a class="zoom-out">' + new WLCIcon('minus') + '</a>';
    var element = jQuery(
      '<div class="zoom-controls">' +
        zoomInButton +
        '<div class="zoom-connector"></div>' +
        zoomOutButton +
        '</div>'
    );

    element.find('.zoom-in').click(function (e) {
      e.preventDefault();
      map.setZoom(map.getZoom() + 1);
    });

    element.find('.zoom-out').click(function (e) {
      e.preventDefault();
      map.setZoom(map.getZoom() - 1);
    });

    return element;
  };

  this.CyclingTrips.prototype.getCenterControl = function (map) {
    var centerButton =
      '<a class="center-button">' + new WLCIcon('center_map') + '</a>';
    var element = jQuery(
      '<div class="center-control">' + centerButton + '</div>'
    );

    element.find('.center-button').click(function (e) {
      e.preventDefault();
      if (window.rtkml && window.rtkml.defaultViewport) {
        map.fitBounds(window.rtkml.defaultViewport);
      } else {
        console.log('Error: var kml_center does not exists');
      }
    });

    return element;
  };

  /*
   * Rating
   */
  this.CyclingTrips.prototype.rating = function () {
    var cookieName = 'cycling_trips_rated';
    var selector = ".rating *[class^='rating-'],.rating *[class*=' rating-']";
    var currentRating = 0;

    // stars show & disappear
    $('.rating').each(function () {
      var t = jQuery(this);
      var id = t.attr('data-id');
      if (isRated(id)) {
        t.addClass('already-rated');
      }
    });

    $(selector).on('mouseenter', function () {
      var ratingNode = $(this).parents('.rating');
      if (!ratingNode.hasClass('already-rated')) {
        $(this).parents('.rating').addClass('rating-now');
        $(this).prevAll().addClass('rating-active');
      }
    });

    $(selector).on('mouseleave', function () {
      $(this).parents('.rating').removeClass('rating-now');
      $(selector).removeClass('rating-active');
    });

    //create html rating
    var wrap = $('<div></div>');
    var popupRating = $('<div class="popup-rating"></div>');
    var header = $('<h2>' + $('h1.entry-title').text() + '</h2>');
    var location = $('header.header .location').clone();
    var ratingBlock = $('<div class="rating-block"></div>');
    var ratingText = $('<p>' + ys.cycling_trips.rate_this_trip + '</p>');
    var stars = $('.popularity .rating').clone();
    stars.addClass('set-rating');
    stars.removeClass('rating-now');
    stars.find('span').removeClass('rating-active');
    stars.find('span').addClass('active');
    stars.find('.value, .ratings').remove();
    var submit = $(
      '<button class="ajax-loader-button submit-rating">' +
        ys.cycling_trips.submit +
        '</button>'
    );
    submit.addClass('disabled');
    var popup = null;

    wrap.append(popupRating);
    popupRating.append(header);
    popupRating.append(location);
    popupRating.append(ratingBlock);
    popupRating.append(submit);

    ratingBlock.append(ratingText);
    ratingBlock.append(stars);

    $(selector).on('click', function () {
      var ratingNode = $(this).parents('.rating');
      var t = $(this);
      if (!ratingNode.hasClass('already-rated')) {
        //user haven't rated yet

        if (typeof WLCPopup === 'function') {
          popup = new WLCPopup(wrap.html(), false);
          popup.show();
          $(
            '.set-rating span[data-rating=' + t.attr('data-rating') + ']'
          ).click();
        }
      }
    });

    $(document).on('click', '.set-rating span', function () {
      var t = $(this);
      currentRating = parseInt(t.attr('data-rating'));
      checkSubmitClass();
      $('.set-rating span').each(function () {
        var t2 = $(this);
        t2.removeClass('active');
        var thisRating = parseInt(t2.attr('data-rating'));
        if (thisRating > currentRating) {
          t2.addClass('active');
        }
      });
    });

    $(document).on('click', '.submit-rating:not(.disabled)', function () {
      var t = $(this);
      var ratingNode = t.siblings('.rating-block').find('.rating');
      var id = ratingNode.attr('data-id');
      var url = ratingNode.attr('data-url');
      addRating(id, currentRating, url);
      $('.rating').addClass('already-rated');
      popup.hide();
      ratingSuccessful();
    });

    function ratingSuccessful() {
      var fb_url = $('.share a.facebook').attr('href');
      var content =
        '<div class="rating-successful">' +
        new WLCIcon('icon_favorite_star') +
        '<h2>' +
        ys.cycling_trips.rating_successful +
        '</h2>' +
        '<p>' +
        ys.cycling_trips.thank_you_for_your_feedback +
        '</p>' +
        '<div class="sharing-block">' +
        '<p>' +
        ys.cycling_trips.let_your_friends_know +
        '</p>' +
        '<a href="' +
        fb_url +
        '" target="_blank" class="share-on-facebook">' +
        new WLCIcon('facebook') +
        '<span>' +
        ys.cycling_trips.share_on_facebook +
        '</span>' +
        '</a>' +
        '</div>' +
        '<h2>' +
        ys.cycling_trips.looking_for_more_fun +
        '</h2>' +
        '<p>' +
        ys.cycling_trips.join_our_instagram +
        '</p>' +
        '</div>';

      if (typeof WLCPopup === 'function') {
        var popup = new WLCPopup(content, false);
        popup.show();
      }
    }

    function checkSubmitClass() {
      if (currentRating === 0) {
        $('.popup-rating button').addClass('disabled');
      } else {
        $('.popup-rating button').removeClass('disabled');
      }
    }

    function getRatings() {
      var ratings = Cookies.get(cookieName);
      if (!ratings) {
        return [];
      } else {
        return JSON.parse(ratings);
      }
    }

    function addRating(id, rating, url) {
      var ratings = getRatings();
      ratings.push(parseInt(id));
      Cookies.set(cookieName, JSON.stringify(ratings));
      var request = $.ajax({
        url: url,
        method: 'POST',
        data: { id: id, rating: rating },
        dataType: 'html',
      });
      request.fail(function (jqXHR, textStatus) {
        if (CTA.debug) {
          console.log(jqXHR);
        }
      });
      request.success(function (html) {
        $('header.header .rating').html(html);
      });
      return request;
    }

    function isRated(id) {
      var ratings = getRatings();
      return ratings.indexOf(parseInt(id)) !== -1;
    }
  };
}).bind(window)(jQuery);
